import { render, staticRenderFns } from "./VentesRetourMenu.vue?vue&type=template&id=6ae64fdc&scoped=true&"
import script from "./VentesRetourMenu.vue?vue&type=script&lang=js&"
export * from "./VentesRetourMenu.vue?vue&type=script&lang=js&"
import style0 from "./VentesRetourMenu.vue?vue&type=style&index=0&id=6ae64fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae64fdc",
  null
  
)

export default component.exports